module.exports = __webpack_public_path__ + "img/szgxq1.2060620d.jpg";